import { useState } from "react";

export const useInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  return [value, (evt) => setValue(evt.target.value)];
};
